export default __webpack_public_path__ + "static/home-rosalind-5206761ee7fed59744d3f78d6226fd3b.jpg";